import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { WebsiteCustomField, WebsiteCustomFieldOption } from '@rx-applications/clientsite/admin/utils';
import { HttpService } from '@rx-applications/shared/utils';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CustomFieldsBackendService {
  #httpClient: HttpClient = inject(HttpClient);
  #httpService: HttpService = inject(HttpService);
  #websiteCustomFields = `${this.#httpService.webApiUrl}Website/CustomFields`;

  getCustomFieldsList(): Observable<WebsiteCustomField[]> {
    return this.#httpClient.get<WebsiteCustomField[]>(this.#websiteCustomFields);
  }

  getCustomFieldById(customFieldId: string): Observable<WebsiteCustomField> {
    return this.#httpClient.get<WebsiteCustomField>(`${this.#websiteCustomFields}/${customFieldId}`);
  }

  setCustomFieldRequired(customFieldId: string, required: boolean): Observable<WebsiteCustomField> {
    const body = { required };
    return this.#httpClient.put<WebsiteCustomField>(`${this.#websiteCustomFields}/${customFieldId}/Required`, body);
  }

  updateCustomFieldOptions(customFieldId: string, options: WebsiteCustomFieldOption[]): Observable<WebsiteCustomField> {
    return this.#httpClient.put<WebsiteCustomField>(`${this.#websiteCustomFields}/${customFieldId}/Options`, {options});
  }
}